<script setup lang="ts">
import { ESection } from '@/components/base/Email'

import EmailBlockWrapper from './EmailBlockWrapper.vue'
import EmailSeparatorToolbar from './EmailSeparatorToolbar.vue'

import type { SeparatorBlock } from '../../types'

const { t } = useI18n()

defineProps<{
  block: SeparatorBlock
  isSelected: boolean
  colorPresets?: { color: string; label: string }[]
}>()

const emit = defineEmits<{
  (e: 'select'): void
  (e: 'update:block', block: SeparatorBlock): void
}>()
</script>

<template>
  <EmailBlockWrapper
    :is-selected="isSelected"
    :label="t('pages.email.emailTemplateCreatePage.blockSeparator')"
    cursor="pointer"
    :block-background-color="block.blockBackgroundColor"
    @select="emit('select')"
  >
    <ESection>
      <div :style="{ padding: `${block.height ?? 16}px 0` }">
        <hr
          :style="{
            border: 'none',
            borderTop: `1px solid #${block.color}`,
            margin: 0
          }"
        />
      </div>
    </ESection>
  </EmailBlockWrapper>
  <EmailSeparatorToolbar
    v-if="isSelected"
    :block="block"
    :color-presets="colorPresets"
    @update:block="emit('update:block', $event)"
  />
</template>
